import { type SierraSecrets } from './getSierraSecretsConfig.ts';

function getSierraSecrets({
    userToken,
    sellerToken,
    sfChatToken,
}: {
    userToken: string | null | undefined;
    sellerToken: string | null | undefined;
    sfChatToken: string | null | undefined;
}): SierraSecrets | undefined {
    if (!userToken && !sellerToken && !sfChatToken) {
        return undefined;
    }

    return {
        ...(userToken && { USER_TOKEN: userToken }),
        ...(sellerToken && { SELLER_TOKEN: sellerToken }),
        ...(sfChatToken && { SALESFORCE_CUSTOMER_IDENTITY_TOKEN: sfChatToken }),
    };
}

export { getSierraSecrets };
